/*
 * AppPreviewComponent.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback, useMemo, useState } from "react";
import { BEM } from "@adapptio/lib-components";
import { DIALOG_SIZE, DialogPanel } from "../../../ui/components/Dialogs/DialogPanel";
import { TDialogComponent } from "../../../dialogs/Dialog";
import { AppPreview } from "./AppPreview";
import { AppPreviewToolbar } from "./components/AppPreviewToolbar";
import { AppPreviewMain } from "./components/AppPreviewMain";
import { Layout } from "../../../ui/components/Layout/Layout";
import { defaultScreenSizeOption, TScreenSizeId } from "./appPreviewScreenSizes";
import { PreviewResolutionProvider } from "../../../previewResolution";

export const AppPreviewComponent: TDialogComponent<AppPreview> = ({ dialog }) => {
	const baseClass = BEM("edt-app-preview");

	const layoutState = useMemo(() => dialog.getLayoutState(), []);
	const history = useMemo(() => dialog.getHistory(), []);
	const [ previewSize, setPreviewSize ] = useState<TScreenSizeId>(defaultScreenSizeOption.id);

	const closePreview = useCallback(() => {
		dialog.close({});
	}, [ dialog ]);

	const changePreviewSize = useCallback(
		(size: string) => {
			// setPreviewSize(size as TScreenSizeId);
		},
		[ setPreviewSize ]
	);

	const navigateToPath = useCallback((path: string) => {
		dialog.navigate(path);
	}, []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "appPreviewToolbar": {
				return (
					<AppPreviewToolbar
						history={history}
						closePreview={closePreview}
						previewSize={previewSize}
						onPreviewSizeChange={changePreviewSize}
						onPathSubmit={navigateToPath}
					/>
				);
			}
			case "appPreviewMain": {
				return <AppPreviewMain renderContext={dialog.getRenderContext()} previewSize={previewSize} />;
			}

			default: {
				return <p>Error: Undefined panel {componentName}.</p>;
			}
		}
	};

	return (
		<DialogPanel size={DIALOG_SIZE.FULL} className={baseClass.toClassName()} preventBaseStyles>
			<PreviewResolutionProvider>
				<div className={baseClass.element("layout").toClassName()}>
					<Layout state={layoutState} renderComponent={renderComponent} />
				</div>
			</PreviewResolutionProvider>
		</DialogPanel>
	);
};
